module.exports = __webpack_public_path__ + "img/hff.86a68219.png";